import { AirconServicePage } from '../../../components/market/AirconServicePage'
import { getAirconPageProps } from '../../../lib/market-pages'
import content from '../../../data/markets/ae/aircon/dubai/ac-coil-chemical-wash'

// Bump by hand when the copy changes (feeds dateModified).
const CONTENT_REVIEWED = '2026-10-03'

export const getStaticProps = () => getAirconPageProps('ae', 'dubai', CONTENT_REVIEWED)

export default function Page(props) {
    return <AirconServicePage {...props} content={content} />
}
